import { createSlice } from "@reduxjs/toolkit";
import { getSections } from "./thunk";

export interface IState {
  sections: any;
  isSectionLoading: boolean;
  isSectionSuccess: boolean;

  error: any;
}

export const initialState: IState = {
  sections: null,
  isSectionLoading: false,
  isSectionSuccess: false,

  error: {},
};

const SectionSlice = createSlice({
  name: "Section",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //getSections
    builder.addCase(getSections.pending, (state: IState, action: any) => {
      state.isSectionLoading = true;
    });
    builder.addCase(getSections.fulfilled, (state: IState, action: any) => {
      state.sections = action.payload.data;
      state.isSectionSuccess = true;
      state.isSectionLoading = false;
    });
    builder.addCase(getSections.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isSectionSuccess = false;
      state.isSectionLoading = false;
    });
  },
});

export default SectionSlice.reducer;